exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-category[data-v-0797d81d]{margin-bottom:2rem;padding-left:100px}.select-category label[data-v-0797d81d]{background:#ccc;padding:.5rem 1rem;cursor:pointer;transition:all .5s ease;font-weight:700}.select-category input[type=radio][data-v-0797d81d]{display:none}.select-category input.active+label[data-v-0797d81d]{background:#036;color:#fff;background-position:0 100%}.block label[data-v-0797d81d]{margin:1rem;font-weight:700;display:block;width:50px}.block input[data-v-0797d81d]{width:180px;margin-right:1rem}input[type=radio][data-v-0797d81d]{height:auto;width:50px}@media only screen and (max-width:768px){.block[data-v-0797d81d]{flex-wrap:wrap}.block input[data-v-0797d81d]{width:calc(100% - 85px);margin-right:0}.block p[data-v-0797d81d]{width:100%;margin:0;text-align:right}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0797d81d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calc/Currency.vue
// module id = 112
// module chunks = 0